import React from 'react'
import PropTypes from 'prop-types'

import { Box, Container, Typography } from '@material-ui/core'
import { useLocation } from 'wouter'

import withApp from 'artkive/hoc/withApp'

import { LinkList, SectionHeading, SitemapLink } from './Sitemap.style'

const Sitemap = ({ groups = [] }) => {
  const [pathname] = useLocation()

  const sections = groups
    .map((group) => ({ ...group, links: group.links.filter(({ path }) => path !== pathname) }))
    .filter(({ links }) => links.length > 0)

  return (
    <Box py={10}>
      <Container maxWidth='sm'>
        <Typography align='center' variant='h2'>
          Sitemap
        </Typography>

        <Box component='nav' aria-label='Sitemap' textAlign='center'>
          {sections.map(({ key, title, links }) => (
            <Box key={key} mt={5}>
              <SectionHeading component='h2'>{title}</SectionHeading>
              <LinkList>
                {links.map(({ title, path }) => (
                  <li key={path}>
                    <SitemapLink href={path}>{title}</SitemapLink>
                  </li>
                ))}
              </LinkList>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  )
}

Sitemap.propTypes = {
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          path: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
}

export default withApp(Sitemap)
